import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import {GameStage} from './components/GameStage'

class App extends Component {
  render() {
    return (
      <div className="App">
        <GameStage />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js